import type { MeResponse } from '@dbrain/shared';

/**
 * Phase 15d (D-183): the person's role as the profile card says it.
 * "Süper yönetici"; a team admin from the company directory is "Ekip
 * yöneticisi · Hukuk", or "Ekip yöneticisi · 2 ekip" for several teams
 * (their tenant role is "member": the directory's ROLE_APP_ADMIN makes them
 * admin of their teams only); "Üye". A company admin of the individual
 * edition keeps "Yönetici".
 */
export type RoleKind = 'owner' | 'admin' | 'domain_admin' | 'member';

export function roleOf(me: Pick<MeResponse, 'tenant' | 'domains'>): { kind: RoleKind; teams: string[] } {
  if (me.tenant.role === 'owner') return { kind: 'owner', teams: [] };
  if (me.tenant.role === 'admin') return { kind: 'admin', teams: [] };
  const teams = (me.domains ?? []).filter((d) => d.admin).map((d) => d.name);
  return teams.length > 0 ? { kind: 'domain_admin', teams } : { kind: 'member', teams: [] };
}

export interface RoleWords {
  owner: string;
  admin: string;
  domainAdmin: string;
  member: string;
  /** "2 ekip" */
  teams: (count: number) => string;
}

export function roleLabel(me: Pick<MeResponse, 'tenant' | 'domains'>, words: RoleWords): string {
  const role = roleOf(me);
  switch (role.kind) {
    case 'owner':
      return words.owner;
    case 'admin':
      return words.admin;
    case 'member':
      return words.member;
    case 'domain_admin':
      return `${words.domainAdmin} · ${role.teams.length === 1 ? role.teams[0] : words.teams(role.teams.length)}`;
  }
}
